import {
  emailMatchesSet,
  normalizedEmailKey,
  normalizeEmailAddress,
  normalizeEmailVariants,
} from '../../EmailScreen/Content/EmailRecipients/emailNormalization';
import {
  fetchOutlookPeopleFromEmailAddresses,
  type OutlookPersonFromEmailJson,
} from '../../requests';
import type {PodRequestFn} from '../../usePodRequest';
import type {PersonLink} from './structs';

export const uniqueEmails = (emails: string[]): string[] => {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of emails) {
    const email = normalizeEmailAddress(raw);
    if (!email) {
      continue;
    }
    const key = normalizedEmailKey(raw);
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    out.push(email);
  }
  return out;
};

export const personHasSyncableMatchingEmail = (
  person: OutlookPersonFromEmailJson,
  outlookEmails: Set<string>
): boolean => {
  return person.emails.some(
    (email) => email.sync && emailMatchesSet(email.value, outlookEmails)
  );
};

export const toPersonLink = (
  person: OutlookPersonFromEmailJson
): PersonLink => ({
  person,
  pinned: false,
  attachmentIds: [],
});

export const fetchPersonLinksForEmails = async (
  request: PodRequestFn,
  agencyId: number,
  emails: string[],
  init?: RequestInit
): Promise<PersonLink[]> => {
  const unique = uniqueEmails(emails);
  if (unique.length === 0) {
    return [];
  }

  const {people} = await fetchOutlookPeopleFromEmailAddresses(
    request,
    agencyId,
    unique,
    init
  );
  const emailSet = new Set(unique.flatMap(normalizeEmailVariants));
  return people
    .filter((person) => personHasSyncableMatchingEmail(person, emailSet))
    .map(toPersonLink);
};
